/*
  nebe-cart-upsell.js: karta „Přihoď si …“ pod položkou v bočním košíku.
  Specifikace = schválený mockup mockup-upsell-kosik/ (chování a texty 1:1).

  Načítá se JEDNOU z layout/theme.liquid (defer, jen při zapnutém drawer a
  settings.nebe_cu_enabled). Boční košík přichází přes Section Rendering API jako
  innerHTML z několika míst (cart-drawer.js, cart.js, gift-threshold.js, nebe-outlet.js),
  takže <script> uvnitř sekce by se nespustil. Proto custom element: po každém
  překreslení se <nebe-cart-upsell> připojí znovu a postaví kartu z JSONu, který mu
  připravil snippets/nebe-cart-upsell.liquid (pravidla, barvy, sklad, ceny, texty).

  Vzhled od 30. 10. 2026 podle mockup-upsell-kosik/desktop.html: varianta A2, vzhled
  „Výraznější“, fotka „Do kraje“ (desktop.js: cardA2, cardSide, cropHTML, nameRow, ddHTML).
  - Desktop (≥ 990 px): karta rovnou rozbalená, bez sbalování.
  - Mobil: pravidla 1 a 2 sbalená, ťuknutí na nadpis nebo fotku rozbalí/sbalí; pravidlo 3
    vždy rozbalené.
  - Pravidla 1 a 2: výběr velikosti je vlastní nabídka (tlačítko + role="listbox" nahoru),
    žádný <select> ani <input> s name.
  - Pravidlo 3: velikost natvrdo z Muse v košíku (d.fix), vybírá se jen barva.

  Zásady (kritika z kódu, 29. 10. 2026):
  - Celý drawer je <form id="cart"> a <cart-items> volá updateQuantity na KAŽDÝ change
    (cart.js:29, 101–104). V kartě jsou proto jen <button type="button"> bez name
    a change/input se v kartě zastaví.
  - Klikání v kartě mění jen atributy a texty uvnitř karty, seznam se nepřekresluje.
  - Výběr (rozbaleno, barva, velikost) přežije překreslení v sessionStorage pod
    klíčem pravidlo + produkt, ne podle řádku, pod kterým karta stojí.
  - Zámek proti dvojkliku je na úrovni modulu (busy). Během „Přidávám“ jsou zamčené
    i +, − a koš u položek, stejně jako v mockupu.
  - Přidání přes theme.routes.cart_add_url (jazyková mutace má vlastní prefix),
    sekce se překreslí BEZ MiniCart.renderContents (ten násilně otevírá drawer),
    vzor gift-threshold.js:90–101. Pak čerstvý /cart.js v události cart:updated,
    protože cart:updated po /cart/add sám nevystřelí (posloucháno v nebe-credit.js
    a nebe-wallet.js).
*/
(() => {
  'use strict';
  if (customElements.get('nebe-cart-upsell')) return;

  const SECTIONS = [
    { id: 'mini-cart', selector: '.shopify-section' },
    { id: 'cart-icon-bubble', selector: '.shopify-section' },
    { id: 'mobile-cart-icon-bubble', selector: '.shopify-section' }
  ];
  const STORE = 'nebe:cu:';            // + pravidlo + ':' + id produktu
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const ADD_TIMEOUT = 10000;           // po 10 s visícího přidání síťová hláška a odemknout košík
  let busy = false;                    // modulový zámek: jedno přidání naráz
  let lastWait = '';                   // text „Chvilku, přidávám“ pro zamčený košík
  const soldOut = {};                  // varianty, které vrátily 422 (do obnovení stránky)

  /* ---------------------------------------------------------------- pomocné */
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  /* Nezlomitelná mezera za jednopísmennými předložkami a spojkami (CS i SK). */
  function nb(t) {
    let prev;
    t = String(t);
    do { prev = t; t = t.replace(/(^|[\s(„ ])([kKsSvVzZoOuUiIaA]) /g, '$1$2 '); } while (t !== prev);
    return t;
  }
  /* Název barvy pro čtečky: „Tělová | svítání“ → „Tělová, svítání“. */
  const sr = (c) => String(c).replace(/\s*\|\s*/g, ', ');
  const fill = (tpl, o) => String(tpl).replace(/\{(\w)\}/g, (m, k) => (o[k] != null ? o[k] : m));
  function ssGet(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ssSet(k, v) { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* soukromé okno */ } }

  /* Cena jako zbytek košíku: v CZK je čárka tisícová → nedělitelná mezera; v EUR
     zůstává (je desetinná). Mezera před měnou nedělitelná. */
  function money(s, cur) {
    s = String(s || '');
    if (cur === 'CZK') s = s.replace(/,/g, ' ');
    return s.replace(/ (Kč|€)/g, ' $1');
  }

  /* Převod velikosti z metapole custom.size_measure_values („75A, 75B, 75C, 75D“)
     do krátkého tvaru z mockupu („75A–D“). Řada košíčků se po DD láme, protože
     v EU značení DD není: „85C, 85D, 85DD, 85E“ → „85C–DD, 85E“. Co nejde
     rozložit, zůstane, jak je. */
  const CUPS = ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'G', 'H'];
  function shortConv(raw) {
    if (!raw) return '';
    const parts = String(raw).split(/\s*,\s*/).filter(Boolean);
    const m = parts.map((p) => /^(\d{2,3})([A-H]{1,2})$/.exec(p.trim()));
    if (!m.length || m.some((x) => !x)) return String(raw);
    const out = [];
    let run = null;
    const run_i = (r) => (r ? r.i : -9);
    const flush = () => {
      if (!run) return;
      out.push(run.band + run.from + (run.to !== run.from ? '–' + run.to : ''));
      run = null;
    };
    m.forEach((x) => {
      const band = x[1], cup = x[2], i = CUPS.indexOf(cup);
      // navazuje: další košíček v řadě, nebo D → E, když DD v řadě chybí („90C, 90D, 90E,
      // 90F“ → „90C–F“); po DD se řada vždy láme („85C–DD, 85E“)
      const next = i === run_i(run) + 1 || (run && run.to === 'D' && cup === 'E');
      if (run && run.band === band && next && run.to !== 'DD') {
        run.to = cup; run.i = i;
      } else {
        flush();
        run = { band, from: cup, to: cup, i };
      }
    });
    flush();
    // Druhý a další úsek stejného obvodu se píše celý („85C–DD, 85E“).
    return out.join(', ');
  }

  /* Živá oblast pro čtečky mimo košík: košík se překresluje, oblast musí přežít. */
  /* Vzniká hned při načtení modulu (skript je defer, body existuje): oblast, která se
     objeví až s prvním hlášením, čtečky často nepřečtou. */
  const live = document.createElement('p');
  live.className = 'nebe-cu-vh';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');
  (document.body || document.documentElement).appendChild(live);
  function announce(t) {
    live.textContent = '';
    setTimeout(() => { live.textContent = nb(t); }, 30);
  }

  /* Rámečky fokusu jen po klávesnici. :focus-visible sám nestačí: po ťuknutí karta
     přesouvá fokus programově (nabídka velikostí, tlačítko) a Chrome pak rámeček někdy
     ukáže. Poslední vstup se proto drží v třídě is-kbd na každé kartě a CSS bez ní
     rámečky skrývá. */
  let kbd = false;
  function setKbd(on) {
    if (kbd === on) return;
    kbd = on;
    document.querySelectorAll('.nebe-cu').forEach((c) => c.classList.toggle('is-kbd', on));
  }
  document.addEventListener('keydown', (e) => { if (!e.metaKey && !e.ctrlKey && !e.altKey) setKbd(true); }, true);
  document.addEventListener('pointerdown', () => setKbd(false), true);

  /* Hláška, která má přežít překreslení košíku (síťová chyba po kontrole košíku):
     nová karta se stejným klíčem si ji při připojení převezme. */
  let pendingMsg = null;

  /* Styl se načítá neblokujícím <link media="print" onload>. Než dojede, karta
     zůstane skrytá (atribut hidden z Liquidu), jinak by vyskočily holé značky. */
  function cssReady() {
    const probe = getComputedStyle(document.documentElement).getPropertyValue('--nebe-cu-css');
    if (probe && probe.trim()) return Promise.resolve();
    const link = document.querySelector('link[href*="nebe-cart-upsell"]');
    return new Promise((res) => {
      if (link) link.addEventListener('load', () => res(), { once: true });
      setTimeout(res, 1500);
    });
  }

  /* Zamčený košík během „Přidávám“: +, −, koš i zápis množství neprojdou.
     Posluchače v capture fázi na document běží dřív než cart-items. */
  function lockedTarget(e) {
    if (!busy) return null;
    const t = e.target;
    if (!t || !t.closest) return null;
    return t.closest('#mini-cart cart-items, .mini-cart cart-items');
  }
  document.addEventListener('click', (e) => {
    if (!lockedTarget(e)) return;
    e.preventDefault();
    e.stopPropagation();
    announce(lastWait);
  }, true);
  ['change', 'input', 'keydown'].forEach((type) => {
    document.addEventListener(type, (e) => {
      if (!lockedTarget(e)) return;
      if (type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  });

  /* Výměna sekcí z odpovědi /cart/add. Vzor gift-threshold.js:90–101 (renderSections):
     tam je to metoda třídy GiftThreshold uvnitř uzavřeného modulu a načítá se jen při
     kampani s dárkem, sdílet ji nejde. MiniCart.renderContents (cart-drawer.js:38–47)
     dělá totéž, ale na konci volá open(), což tady nechceme (drawer je otevřený a
     open() přesouvá fokus). */
  function renderSections(sections) {
    let drawer = false;
    SECTIONS.forEach((s) => {
      const box = document.getElementById(s.id);
      const html = sections && sections[s.id];
      if (!box || !html) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
      if (!parsed) return;
      box.innerHTML = parsed.innerHTML;
      if (s.id === 'mini-cart') drawer = true;
    });
    return drawer; // true jen když se opravdu vyměnil obsah #mini-cart
  }

  /* Překreslení košíku bez odpovědi z /cart/add (po síťové chybě): sekce přes
     Section Rendering API, a když to nevyjde, cart:refresh motivu (global.js
     CartDrawer.onCartRefresh, drawer bez detail.open neotevírá). */
  async function refreshDrawer() {
    try {
      const url = routes().root + '?sections=' + SECTIONS.map((x) => x.id).join(',');
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (res.ok && renderSections(await res.json())) return;
    } catch (e) { /* záloha níž */ }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  /* Košík po přidání: pubsub motivu (cart-update) jako po přidání z PDP (nebe-pdp.js),
     ať se dozví cart-items, nebe-credit, nebe-wallet i nebe-outlet. sections: {} schválně:
     cart-items.onCartUpdate (cart.js:50–60) pak nic nepřekresluje (drawer už je
     překreslený) a nespadne na parsedState.sections; cart:updated pošle sám (cart.js:68).
     open() se nevolá nikde. Bez pubsubu (nebo při chybě) pošleme cart:updated sami.
     cart-live-region-text v drawer není (je jen na /cart, kde karta neběží), hlášení
     pro čtečky jde přes vlastní živou oblast výš. */
  async function notifyCart(variantId, cart) {
    try {
      if (!cart) cart = await fetch(routes().cart, { headers: { Accept: 'application/json' } }).then((x) => x.json());
    } catch (e) { return; }
    let done = false;
    try {
      // PUB_SUB_EVENTS je v pubsub.js const, na window není: holý identifikátor s typeof
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'nebe-cart-upsell',
          productVariantId: String(variantId),
          cart: Object.assign({}, cart, { sections: {} })
        });
        done = !!document.querySelector('#mini-cart cart-items');
      }
    } catch (e) { done = false; }
    if (!done) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'nebe-cart-upsell' } }));
  }

  /* Po síťové chybě nevíme, jestli Shopify kus přidal (abort po 10 s, 5xx, rozbitá
     odpověď). Karta se ukazuje jen tehdy, když v košíku žádný řádek karty není
     (cu_upsold v Liquidu), takže řádek s touto variantou a naším _upsell_source
     znamená, že přidání prošlo. Vrací { added, cart } nebo null (nevíme). */
  async function checkAdded(variantId, source) {
    const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    const timer = ctrl ? setTimeout(() => ctrl.abort(), 5000) : null;
    try {
      const cart = await fetch(routes().cart, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined }).then((x) => x.json());
      const added = (cart.items || []).some((i) => i.variant_id === variantId && i.properties && i.properties._upsell_source === source);
      return { added, cart };
    } catch (e) {
      return null;
    } finally {
      if (timer) clearTimeout(timer);
    }
  }

  function routes() {
    const r = (window.theme && window.theme.routes) || window.routes || {};
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return {
      root,
      add: r.cart_add_url || root + 'cart/add',
      cart: (r.cart_url || root + 'cart').replace(/\/$/, '') + '.js'
    };
  }

  /* Dostupnost varianty po 422: true/false, null = nevíme (síť, 429, timeout 5 s). */
  async function variantAvailable(id) {
    const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    const timer = ctrl ? setTimeout(() => ctrl.abort(), 5000) : null;
    try {
      const res = await fetch(routes().root + 'variants/' + id + '.js', { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined });
      if (!res.ok) return null;
      const j = await res.json();
      return typeof j.available === 'boolean' ? j.available : null;
    } catch (e) {
      return null;
    } finally {
      if (timer) clearTimeout(timer);
    }
  }

  /* ================================================================ element */
  const DESK = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: false };
  const ARROW = '<svg class="nebe-cu-arr" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><path d="M6 3.5l4.5 4.5L6 12.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const CHEV_DOWN = 'M6 9l6 6 6-6', CHEV_UP = 'M6 15l6-6 6 6';
  /* Ručně kreslená čára pod pointou nadpisu (mockup desktop.js headHTML, DESIGN.md §4). */
  const SCRIBBLE = '<svg viewBox="-340 -62 680 128" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path d="M-335,54 C-335,54 -171,-58 -194,-3 C-217,52 -224.12,73.552 -127,11 C-68,-27 -137,50 -33,42 C31.439,37.043 147.147,-29.308 335,2" vector-effect="non-scaling-stroke"/></svg>';

  /* Řádek s názvem (mockup desktop.js nameRow): obsahuje-li nadpis krátký název
     (poslední slovo názvu), řádek s názvem se vynechá; obsahuje-li kmen typu (první
     slovo bez koncovky), stačí krátký název; jinak celý název.
     „Ještě něco pro ni?“ → „podprsenka Muse“, „…pohodlnou podprsenku“ → „Muse“,
     „Přihoď si Muse i v jiné barvě“ → nic. */
  function nameRow(head, title) {
    const words = String(title).trim().split(/\s+/);
    const short = words[words.length - 1] || '';
    const type = words[0] || '';
    const h = String(head).toLowerCase();
    if (short && h.indexOf(short.toLowerCase()) !== -1) return '';
    if (words.length > 1 && type.length > 4 && h.indexOf(type.slice(0, -1).toLowerCase()) !== -1) return short;
    return title;
  }

  class NebeCartUpsell extends HTMLElement {
    connectedCallback() {
      if (this._built) return;
      const json = this.querySelector('script[data-nebe-cu]');
      try { this.d = JSON.parse(json.textContent); } catch (e) { return; }
      if (!this.d || !this.d.colors || !this.d.colors.length) return;
      this._built = true;
      this.t = this.d.t;
      this.fix = this.d.fix || null;          // pravidlo 3: velikost natvrdo z košíku
      lastWait = this.t.wait;
      this.key = STORE + this.d.rule + ':' + this.d.museId;
      this.restore();
      if (this.fix && !this.offered(this.s.k, this.fix)) return; // nic k nabídnutí
      let focusAdd = false;
      if (pendingMsg && pendingMsg.key === this.key) {
        this.s.msg = pendingMsg.text; this.s.err = true; focusAdd = pendingMsg.focus;
        pendingMsg = null;
      }
      this.build();
      this.update();
      this._mq = () => { this.closePop(false); this.update(); };
      if (DESK.addEventListener) DESK.addEventListener('change', this._mq);
      // Element přichází z Liquidu s hidden; sundat až s načteným CSS.
      // Fokus na tlačítko (hláška po síťové chybě) až po odkrytí, skrytý prvek fokus nebere.
      cssReady().then(() => {
        this.setAttribute('data-ready', '');
        this.hidden = false;
        if (focusAdd) this.btnAdd.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      if (this._mq && DESK.removeEventListener) DESK.removeEventListener('change', this._mq);
      if (this._outside) document.removeEventListener('click', this._outside, true);
    }

    /* ---------- sklad ---------- */
    color(k) { return this.d.colors.find((c) => c.k === k) || null; }
    variant(k, z) { const c = this.color(k); return c && c.v ? c.v[z] || null : null; }
    inStock(k, z) { const v = this.variant(k, z); return !!(v && v.a && !soldOut[v.id]); }
    inCart(k, z) { const v = this.variant(k, z); return !!(v && v.c); }
    offered(k, z) { return this.inStock(k, z) && !this.inCart(k, z); }
    /* 'ok' = jde přidat, 'allincart' = skladové velikosti už jsou v košíku, 'soldout' = nic skladem.
       U pravidla 3 jen pro pevnou velikost: 'ok' / 'allincart' (ta velikost už v košíku) / 'soldout'. */
    colorState(k) {
      if (this.fix) return this.offered(k, this.fix) ? 'ok' : (this.inCart(k, this.fix) ? 'allincart' : 'soldout');
      let stock = false;
      for (const z of this.d.sizes) {
        if (this.inStock(k, z)) { stock = true; if (!this.inCart(k, z)) return 'ok'; }
      }
      return stock ? 'allincart' : 'soldout';
    }
    firstOk() {
      if (this.colorState(this.d.def) === 'ok') return this.d.def;
      const c = this.d.colors.find((x) => this.colorState(x.k) === 'ok');
      return c ? c.k : this.d.def;
    }
    isOpen() { return !!this.fix || DESK.matches || this.s.x; }

    /* ---------- výběr (sessionStorage, klíč pravidlo + produkt) ----------
       Spolu s výběrem se ukládá serverový kontext karty: výchozí barva, předvolba
       velikosti a řádek, pod kterým karta stojí (item.key). Když se kontext změní
       (Aura vyměněná za černé ponožky, první Muse v jiné velikosti), uložený výběr
       neplatí a karta začne od výchozího stavu ze serveru. Při +/− u jiné položky
       se kontext nemění, výběr přežije. */
    ctx() { return [this.d.def, this.d.preset || '', this.getAttribute('data-anchor') || ''].join('~'); }
    restore() {
      const saved = ssGet(this.key);
      const s = { x: false, k: this.firstOk(), z: this.fix || this.d.preset, msg: null, err: false, pop: false, act: 0 };
      if (saved && saved.c === this.ctx() && this.color(saved.k) && this.colorState(saved.k) === 'ok') {
        s.x = !!saved.x; s.k = saved.k; s.z = this.fix || saved.z || null;
      }
      if (!this.fix && s.z && !this.offered(s.k, s.z)) s.z = null;
      this.s = s;
    }
    save() { ssSet(this.key, { c: this.ctx(), x: this.s.x, k: this.s.k, z: this.fix ? null : this.s.z }); }

    /* ---------- kostra karty (jednou) ---------- */
    build() {
      const t = this.t, d = this.d, fix = this.fix;
      const sw = d.colors.map((c) => (
        '<button type="button" role="radio" class="nebe-cu-sw" data-act="color" data-k="' + esc(c.k) + '"' +
          ' title="' + esc(c.n) + '" style="--nebe-cu-swc:' + esc(c.sw) + '"><i aria-hidden="true"></i></button>'
      )).join('');

      // nadpis s čárou pod pointou („pro ni“ / „pohodlnou“ / „jiné barvě“)
      let head = esc(nb(t.head));
      const hl = esc(nb(t.hl || ''));
      if (hl && head.indexOf(hl) !== -1) head = head.replace(hl, '<span class="nebe-cu-hl">' + hl + SCRIBBLE + '</span>');
      // Mobil: nadpis je tlačítko, které kartu sbalí/rozbalí. Desktop: prostý text.
      // Obě podoby jsou v DOM, CSS ukazuje jednu (display: none ji vyřadí i pro čtečky).
      const headHTML = fix
        ? '<p class="nebe-cu__head" id="nebe-cu-h">' + head + '</p>'
        : '<p class="nebe-cu__head" id="nebe-cu-h"><span class="nebe-cu__hd-desk">' + head + '</span>' +
            '<button type="button" class="nebe-cu__headbtn" data-act="toggle" aria-expanded="false" aria-controls="nebe-cu-in">' + head +
            '<svg class="nebe-cu__chev" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="' + CHEV_UP + '" fill="none" stroke="currentColor" stroke-width="1.8"/></svg></button></p>';

      const name = nameRow(t.head, d.title);
      const c0 = this.color(this.s.k) || d.colors[0];
      // Vždy <img>: barva bez fotky ho má skryté (hidden) a update() fotku nasadí,
      // jakmile se vybere barva, která ji má.
      const media = c0 && c0.img
        ? '<img src="' + esc(c0.img) + '" alt="" width="96" height="120" loading="lazy" data-r="img">'
        : '<img alt="" width="96" height="120" loading="lazy" data-r="img" hidden>';

      const pick = fix
        ? '<div class="nebe-cu__pick"><button type="button" class="nebe-cu__add nebe-cu__add--fixed" data-act="add"></button></div>'
        : '<div class="nebe-cu__pick">' +
            '<div class="nebe-cu-dd">' +
              '<button type="button" class="nebe-cu-ddbtn" data-act="dd" aria-haspopup="listbox" aria-expanded="false" aria-controls="nebe-cu-lb">' +
                '<span data-r="ddlbl"></span><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path data-r="ddchev" d="' + CHEV_DOWN + '" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>' +
              '</button>' +
              '<ul class="nebe-cu-pop" id="nebe-cu-lb" role="listbox" tabindex="-1" aria-label="' + esc(t.size) + '" hidden>' +
                d.sizes.map((z, i) => '<li role="option" id="nebe-cu-o' + i + '" class="nebe-cu-opt" data-act="opt" data-z="' + esc(z) + '">' + esc(z) + '<span class="nebe-cu-vh"></span></li>').join('') +
              '</ul>' +
            '</div>' +
            '<button type="button" class="nebe-cu__add" data-act="add"></button>' +
          '</div>' +
          '<p class="nebe-cu__conv2"><span data-r="conv"></span>' +
            (d.table ? '<a href="' + esc(d.table) + '" class="nebe-cu-table">' + esc(t.table) + '</a>' : '') + '</p>';

      const card = document.createElement('section');
      card.className = 'nebe-cu' + (fix ? ' nebe-cu--fixed' : '') + (kbd ? ' is-kbd' : '');
      card.setAttribute('aria-labelledby', 'nebe-cu-h');
      card.setAttribute('data-rule', d.rule);
      card.innerHTML =
        (fix && t.badge ? '<p class="nebe-cu-tab">' + esc(nb(t.badge)) + '</p>' : '') +
        '<div class="nebe-cu__media ignore-empty"' + (fix ? '' : ' data-act="toggle"') + '>' + media + '</div>' +
        '<div class="nebe-cu__txt">' +
          headHTML +
          '<p class="nebe-cu__name">' + (name ? '<span class="nebe-cu__pname">' + esc(name) + '</span> ' : '') +
            '<span class="nebe-cu__price" data-r="price"></span><span data-r="was"></span></p>' +
          (fix ? '' : '<div class="nebe-cu__row3"><button type="button" class="nebe-cu__toggle" data-act="toggle" tabindex="-1" aria-hidden="true">' + esc(t.open) + '<span aria-hidden="true"> ›</span></button></div>') +
          '<div class="nebe-cu__inner" id="nebe-cu-in">' +
            '<div class="nebe-cu__swrow"><span class="nebe-cu__swlbl" aria-hidden="true">' + esc(t.colorLbl) + '</span>' +
              '<div class="nebe-cu__sw" role="radiogroup" aria-label="' + esc(t.color) + '">' + sw + '</div></div>' +
            pick +
            '<p class="nebe-cu__msg" data-r="msg" hidden></p>' +
          '</div>' +
        '</div>';
      this.appendChild(card);
      this.card = card;
      this.r = {};
      card.querySelectorAll('[data-r]').forEach((el) => { this.r[el.getAttribute('data-r')] = el; });
      this.headBtn = card.querySelector('.nebe-cu__headbtn');
      this.btnAdd = card.querySelector('.nebe-cu__add');
      this.ddBtn = card.querySelector('.nebe-cu-ddbtn');
      this.pop = card.querySelector('.nebe-cu-pop');
      this.opts = Array.prototype.slice.call(card.querySelectorAll('.nebe-cu-opt'));

      card.addEventListener('click', (e) => this.onClick(e));
      card.addEventListener('keydown', (e) => this.onKey(e));
      // Esc v nabídce velikostí nesmí zavřít celý košík: MenuDrawer v global.js zavírá na keyup.
      card.addEventListener('keyup', (e) => {
        if (this._swallowEsc && (e.key === 'Escape' || e.code === 'Escape')) { e.stopPropagation(); this._swallowEsc = false; }
      });
      // Drawer je <form id="cart"> a cart-items posílá každý change jako /cart/change.
      ['change', 'input'].forEach((type) => this.addEventListener(type, (e) => e.stopPropagation()));
    }

    /* ---------- stav → atributy a texty (bez překreslení) ---------- */
    update() {
      const t = this.t, d = this.d, s = this.s, fix = this.fix;
      const c = this.color(s.k);
      const isBusy = busy && this._adding;
      const open = this.isOpen();

      this.card.classList.toggle('is-open', open);
      this.card.classList.toggle('is-busy', !!isBusy);
      if (this.headBtn) this.headBtn.setAttribute('aria-expanded', String(open));

      // fotka barvy (barvy bez fotky mají jen nude plochu .nebe-cu__media)
      const img = this.r.img;
      if (c && c.img) {
        if (img.getAttribute('src') !== c.img) img.src = c.img;
        img.hidden = false;
      } else {
        img.hidden = true;
      }

      // cena vybrané varianty, bez velikosti první dostupné v barvě
      let v = s.z ? this.variant(s.k, s.z) : null;
      if (!v && c) {
        const z = d.sizes.find((x) => this.offered(s.k, x)) || d.sizes.find((x) => this.variant(s.k, x));
        v = z ? this.variant(s.k, z) : null;
      }
      this.r.price.textContent = v ? money(v.p, d.cur) : '';
      if (v && v.cp) {
        this.r.was.innerHTML = ' <s><span class="nebe-cu-vh">' + esc(t.was) + '</span>' + esc(money(v.cp, d.cur)) + '</s>';
      } else {
        this.r.was.textContent = '';
      }

      // barvy
      this.card.querySelectorAll('.nebe-cu-sw').forEach((b) => {
        const k = b.getAttribute('data-k');
        const col = this.color(k);
        const cs = this.colorState(k);
        const off = !fix && !!(s.z && cs === 'ok' && !this.offered(k, s.z));
        b.classList.toggle('is-out', cs !== 'ok');
        b.classList.toggle('is-nosize', cs === 'ok' && off);
        b.setAttribute('aria-checked', String(k === s.k));
        if (cs !== 'ok') b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
        b.setAttribute('data-cs', cs);
        let label = sr(col.n);
        if (fix) {
          if (cs === 'allincart') label += ', ' + fill(t.fixInCartSr, { s: fix });
          else if (cs === 'soldout') label += ', ' + fill(t.fixOutSr, { s: fix });
        } else if (cs === 'soldout') label += ', ' + t.soldout;
        else if (cs === 'allincart') label += ', ' + t.noadd;
        else if (off) label += ', ' + fill(t.nosize, { s: s.z });
        b.setAttribute('aria-label', label);
        // roving tabindex: do skupiny vede jeden tab stop, po ní se chodí šipkami
        b.tabIndex = k === s.k ? 0 : -1;
      });

      if (!fix) {
        // tlačítko velikosti + nabídka
        this.r.ddlbl.innerHTML = esc(t.sizeBtn) + (s.z ? ' <b>' + esc(s.z) + '</b>' : '');
        this.ddBtn.setAttribute('aria-expanded', String(!!s.pop));
        this.r.ddchev.setAttribute('d', s.pop ? CHEV_UP : CHEV_DOWN);
        this.pop.hidden = !s.pop;
        if (s.pop) this.pop.setAttribute('aria-activedescendant', 'nebe-cu-o' + s.act);
        else this.pop.removeAttribute('aria-activedescendant');
        this.opts.forEach((o, i) => {
          const z = o.getAttribute('data-z');
          const out = !this.inStock(s.k, z), inc = !out && this.inCart(s.k, z);
          o.classList.toggle('is-out', out);
          o.classList.toggle('is-incart', inc);
          o.classList.toggle('is-active', i === s.act);
          o.setAttribute('aria-selected', String(s.z === z));
          if (out || inc) o.setAttribute('aria-disabled', 'true'); else o.removeAttribute('aria-disabled');
          o.lastChild.textContent = out ? ', ' + t.soldout : (inc ? ', ' + t.incart : '');
        });
        // převod jen pro vybranou velikost: vidět „M = 75A–D · “, čtečka „M odpovídá 75A–D“
        const conv = s.z && d.conv ? shortConv(d.conv[s.z]) : '';
        this.r.conv.innerHTML = conv
          ? '<span class="nebe-cu__cv"><span aria-hidden="true">' + esc(s.z + ' = ' + conv) + '</span><span class="nebe-cu-vh">' + esc(fill(t.conv, { s: s.z, c: conv })) + '</span></span><span aria-hidden="true"> · </span>'
          : '';
      }

      // tlačítko přidání
      const b = this.btnAdd;
      if (isBusy) {
        b.innerHTML = '<span class="nebe-cu-spin" aria-hidden="true"></span>' + esc(t.adding);
      } else if (fix || s.z) {
        b.innerHTML = esc(t.add) + ARROW;
      } else {
        // neaktivní říká dál „Přidat do košíku“ („Vyber velikost“ by se vedle „Velikost ▾“
        // opakovalo); důvod dostane čtečka v aria-label
        b.textContent = t.add;
      }
      if (isBusy || (!fix && !s.z)) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
      if (fix) b.setAttribute('aria-label', fill(t.addFix, { t: d.title, c: c ? sr(c.n) : '', s: fix }));
      else if (!s.z && !isBusy) b.setAttribute('aria-label', t.addNeed);
      else b.removeAttribute('aria-label');

      // hláška
      const m = this.r.msg;
      if (s.msg) {
        m.textContent = nb(s.msg);
        m.classList.toggle('is-error', !!s.err);
        m.hidden = false;
      } else {
        m.textContent = '';
        m.hidden = true;
      }
    }

    /* Hláška se po zobrazení dotočí do viditelné plochy, jinak by mohla skončit
       pod připnutou patičkou košíku. */
    setMsg(text, err) {
      this.s.msg = text;
      this.s.err = !!err;
      this.update();
      if (text) this.r.msg.scrollIntoView({ block: 'nearest' });
    }

    /* ---------- nabídka velikostí (listbox nad tlačítkem) ---------- */
    openPop() {
      const s = this.s, d = this.d;
      let i = d.sizes.indexOf(s.z);
      if (i < 0) i = d.sizes.findIndex((z) => this.offered(s.k, z));
      s.act = Math.max(0, i);
      s.pop = true;
      this.update();
      this.pop.focus({ preventScroll: true });
      this.pop.scrollIntoView({ block: 'nearest' });
      if (!this._outside) {
        // klik mimo nabídku ji zavře (capture: dřív než cokoli jiného v košíku)
        this._outside = (e) => {
          const dd = this.card.querySelector('.nebe-cu-dd');
          if (dd && dd.contains(e.target)) return;
          this.closePop(false);
        };
      }
      document.addEventListener('click', this._outside, true);
    }
    closePop(focusBtn) {
      if (this._outside) document.removeEventListener('click', this._outside, true);
      if (!this.s.pop) return;
      this.s.pop = false;
      this.update();
      if (focusBtn && this.ddBtn) this.ddBtn.focus();
    }
    /* Výběr velikosti z nabídky. Vyprodaná / už v košíku: hláška, nabídka zůstane otevřená. */
    chooseSize(z) {
      const s = this.s, t = this.t;
      if (!this.inStock(s.k, z)) { this.setMsg(fill(t.sizeOut, { s: z, c: sr(this.color(s.k).n) }), true); return false; }
      if (this.inCart(s.k, z)) { this.setMsg(t.sizeInCart, true); return false; }
      s.z = z; s.msg = null; s.err = false;
      this.save();
      return true;
    }

    onKey(e) {
      if (busy) return;
      const k = e.key;
      // Kolečka barev = radiogroup: šipky (a Home/End) přesunou výběr na další barvu, kterou
      // jde vybrat, a fokus s ním (roving tabindex). Přeškrtnuté se přeskakují.
      const sw = e.target.closest && e.target.closest('.nebe-cu-sw');
      if (sw && ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'].indexOf(k) !== -1) {
        e.preventDefault();
        const all = Array.prototype.slice.call(this.card.querySelectorAll('.nebe-cu-sw'));
        const ok = all.filter((b) => b.getAttribute('aria-disabled') !== 'true');
        if (!ok.length) return;
        let i = ok.indexOf(sw);
        if (k === 'Home') i = 0;
        else if (k === 'End') i = ok.length - 1;
        else if (k === 'ArrowRight' || k === 'ArrowDown') i = i < 0 ? 0 : (i + 1) % ok.length;
        else i = i < 0 ? ok.length - 1 : (i - 1 + ok.length) % ok.length;
        const target = ok[i];
        this.chooseColor(target.getAttribute('data-k'));
        target.focus();
        return;
      }
      if (this.fix) return;
      const s = this.s, n = this.d.sizes.length;
      if (e.target === this.ddBtn && (k === 'ArrowDown' || k === 'ArrowUp')) {
        e.preventDefault();
        this.openPop();
        return;
      }
      if (e.target !== this.pop || !s.pop) return;
      // mřížka 3 × 2: vlevo/vpravo o jednu, nahoru/dolů o řadu
      let move = null;
      if (k === 'ArrowRight') move = Math.min(n - 1, s.act + 1);
      else if (k === 'ArrowLeft') move = Math.max(0, s.act - 1);
      else if (k === 'ArrowDown') move = Math.min(n - 1, s.act + 3);
      else if (k === 'ArrowUp') move = Math.max(0, s.act - 3);
      else if (k === 'Home') move = 0;
      else if (k === 'End') move = n - 1;
      if (move !== null) { e.preventDefault(); s.act = move; this.update(); return; }
      if (k === 'Enter' || k === ' ') {
        e.preventDefault();
        if (this.chooseSize(this.d.sizes[s.act])) this.closePop(true);
        return;
      }
      if (k === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        this._swallowEsc = true;
        this.closePop(true);
        return;
      }
      if (k === 'Tab') this.closePop(false);
    }

    /* ---------- akce ---------- */
    onClick(e) {
      const b = e.target.closest('[data-act]');
      if (!b || !this.card.contains(b)) return;
      e.preventDefault();
      // Během „Přidávám“ je zamčená i karta (stejně jako v mockupu).
      if (busy) { announce(this.t.wait); return; }
      const act = b.getAttribute('data-act');
      const s = this.s, t = this.t;

      if (act === 'toggle') { this.toggle(); return; }

      if (act === 'color') { this.chooseColor(b.getAttribute('data-k')); return; }

      if (act === 'dd') {
        if (s.pop) this.closePop(true); else this.openPop();
        return;
      }
      if (act === 'opt') {
        if (this.chooseSize(b.getAttribute('data-z'))) this.closePop(true);
        else this.pop.focus({ preventScroll: true });
        return;
      }

      if (act === 'add') this.add();
    }

    chooseColor(k) {
      const s = this.s, t = this.t;
      const col = this.color(k);
      const cs = this.colorState(k);
      if (this.fix && cs !== 'ok') {
        // přeškrtnutá barva u pevné velikosti: nejde vybrat, jen vysvětlit proč
        const short = String(col.n).split('|')[0].trim();
        this.setMsg(fill(cs === 'allincart' ? t.fixInCart : t.fixOut, { c: short, s: this.fix }));
        return;
      }
      if (cs === 'soldout') { this.setMsg(fill(t.colorOut, { c: sr(col.n) })); return; }
      if (cs === 'allincart') { this.setMsg(t.colorNoAdd); return; }
      s.k = k; s.msg = null;
      if (!this.fix && s.z && !this.offered(k, s.z)) {
        const z = s.z;
        s.z = null;
        this.save();
        this.setMsg(fill(t.colorNoSize, { s: z, c: sr(col.n) }));
        return;
      }
      this.save();
      this.update();
      announce(sr(col.n));
    }

    /* Mobil, pravidla 1 a 2: nadpis nebo fotka kartu rozbalí/sbalí. Desktop a pravidlo 3: nic. */
    toggle() {
      if (this.fix || DESK.matches) return;
      const s = this.s;
      s.x = !s.x;
      if (!s.x) { s.pop = false; s.msg = null; }
      this.save();
      this.update();
      // Fokus se nepřesouvá: z klávesnice zůstává na nadpisu (to je jediný ovládací prvek
      // pro klávesnici), po ťuknutí na fotku by přesun na nadpis ukázal rámeček.
      if (s.x) this.card.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    lockCart(on) {
      const ci = this.closest('cart-items');
      if (ci) ci.classList.toggle('nebe-cu-locked', on);
    }

    async add() {
      if (busy) { announce(this.t.wait); return; }
      const s = this.s, t = this.t, d = this.d;
      if (!s.z) {
        // neaktivní tlačítko: otevřít nabídku velikostí a říct proč
        s.msg = t.pickFirst; s.err = true;
        this.openPop();
        announce(t.pickFirst);
        return;
      }
      const k = s.k, z = s.z;
      const v = this.variant(k, z);
      const cname = this.color(k).n;
      if (!v || !this.offered(k, z)) {
        this.setMsg(t.changed, true);
        announce(t.changedSr);
        return;
      }

      busy = true;
      this._adding = true;
      s.msg = null;
      s.pop = false;
      this.lockCart(true);
      this.update();

      // Výsledek: 'ok' (sections), 'soldout' (422 a varianta je opravdu nedostupná),
      // 'e422' (422 z jiného důvodu), 'net' (síť, timeout, 5xx, nečitelná odpověď).
      // Síťová chyba (abort po 10 s, 5xx, rozbitá odpověď): Shopify kus mohl přidat.
      // Po krátké pauze (request mohl na serveru doběhnout až po abortu) se podívat do
      // košíku, ještě POD zámkem, aby druhé ťuknutí nepřidalo druhou Muse. Řádek karty
      // v košíku = úspěch ('added'), jinak teprve nabídnout opakování. Zámek tak trvá
      // nejvýš 10 s + 1,2 s + 5 s (timeout kontroly).
      let out = { kind: 'net' };
      let cartNow = null;
      try {
        try { out = await this.post(v); } catch (e) { out = { kind: 'net' }; }
        if (out.kind === 'net') {
          await new Promise((r) => setTimeout(r, 1200));
          const chk = await checkAdded(v.id, d.source);
          if (chk && chk.added) { out = { kind: 'added' }; cartNow = chk.cart; }
        }
      } catch (e) {
        out = { kind: 'net' };
      } finally {
        // Zámek se uvolní VŽDY, ať request skončil jakkoli; jinak by visel nad +/−/koš.
        busy = false;
        this._adding = false;
        this.lockCart(false);
      }

      // Nepřidáno (nebo nevíme): košík se stejně překreslí, hláška přežije přes pendingMsg.
      if (out.kind === 'net') {
        pendingMsg = { key: this.key, text: t.net, focus: true };
        announce(t.net);
        // když se košík překreslit nepovede, hláška zůstane aspoň na téhle kartě
        this.setMsg(t.net, true);
        await refreshDrawer();
        // karta se nepřekreslila (cart:refresh běží na pozadí nebo selhal): hláška už je tady
        if (this.isConnected && document.contains(this)) setTimeout(() => { if (pendingMsg && pendingMsg.key === this.key) pendingMsg = null; }, 3000);
        return;
      }

      if (out.kind === 'ok' || out.kind === 'added') {
        // Hotovo: karta po překreslení už nenaskočí (žádné řetězení, cu_upsold).
        ssSet(this.key, null);
        let painted = false;
        try { painted = out.kind === 'ok' && renderSections(out.state.sections); } catch (e) { painted = false; }
        // Záloha: když se #mini-cart z odpovědi nevyměnil (nebo odpověď žádnou nemá),
        // dotáhnout sekce znovu, případně cart:refresh motivu.
        if (!painted) await refreshDrawer();
        try { this.afterAdd(v.id); } catch (e) { /* jen zvýraznění řádku */ }
        announce(fill(t.added, { t: d.title, c: sr(cname), s: z }));
        await notifyCart(v.id, cartNow);
        return;
      }

      let msg;
      if (out.kind === 'soldout') {
        soldOut[v.id] = true;
        msg = fill(t.e422, { s: z, c: sr(cname) });
        if (this.fix) {
          // pravidlo 3: barva bez té velikosti se přeškrtne, vybere se další dostupná
          const next = this.d.colors.find((x) => this.offered(x.k, this.fix));
          if (next) s.k = next.k;
          else { this.update(); announce(msg); this.hidden = true; return; }
        } else {
          s.z = null;
        }
        this.save();
      } else if (out.kind === 'e422') {
        msg = t.e422other;
      } else {
        msg = t.net;
      }
      this.setMsg(msg, true);
      announce(msg);
      this.btnAdd.focus({ preventScroll: true });
    }

    /* Samotné přidání. Timeout 10 s přes AbortController: visící request by jinak
       držel zámek košíku napořád. */
    async post(v) {
      const d = this.d;
      const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      const timer = ctrl ? setTimeout(() => ctrl.abort(), ADD_TIMEOUT) : null;
      // Hlavičky jako zbytek motivu (global.js fetchConfig: JSON tam i zpět).
      const base = typeof window.fetchConfig === 'function' ? window.fetchConfig('json')
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      let res;
      try {
        res = await fetch(routes().add, Object.assign({}, base, {
          body: JSON.stringify({
            items: [{ id: v.id, quantity: 1, properties: { _upsell_source: d.source } }],
            sections: SECTIONS.map((x) => x.id).join(','),
            sections_url: window.location.pathname
          }),
          signal: ctrl ? ctrl.signal : undefined
        }));
      } finally {
        if (timer) clearTimeout(timer);
      }
      if (res.status === 422) {
        // 422 vrací Shopify lokalizovaný text („… je již vyprodán“ / „… byla přidána pouze
        // 1 položka“), podle něj se rozhodovat nedá. Skutečný stav varianty proto zjistí
        // /variants/<id>.js (pole available). Přeškrtne se jen opravdu nedostupná velikost;
        // když dotaz selže nebo je varianta dostupná, obecná hláška bez přeškrtnutí.
        const avail = await variantAvailable(v.id);
        return { kind: avail === false ? 'soldout' : 'e422' };
      }
      if (!res.ok) return { kind: 'net' };
      const state = await res.json();
      return state && typeof state === 'object' ? { kind: 'ok', state } : { kind: 'net' };
    }

    /* Po překreslení: nový řádek (Shopify ho dává nahoru) krátce zvýraznit,
       dorolovat k němu a dát na něj fokus. Starý element už není v DOM, proto
       se hledá v dokumentu. */
    afterAdd(variantId) {
      const li = document.querySelector('#mini-cart li[data-variant-id="' + variantId + '"]');
      if (!li) return;
      li.classList.add('nebe-cu-new');
      setTimeout(() => li.classList.remove('nebe-cu-new'), 1500);
      li.setAttribute('tabindex', '-1');
      li.scrollIntoView({ block: 'nearest' });
      li.focus({ preventScroll: true });
    }
  }

  customElements.define('nebe-cart-upsell', NebeCartUpsell);

  // Pro headless kontrolu a ladění.
  window.NebeCartUpsell = { shortConv, nameRow, isBusy: () => busy };
})();
